import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import { authorization } from 'Module/Auth/Auth'
import React, { useState } from 'react'
import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'
import { deleteClientCodes } from '../../../gql/deleteClientCodes'
import ClientCodeUploadPopup from '../../Popups/CodeUploadPopups/ClientCodes'
import ConfirmationPopup from '../../Popups/ConfirmationPopup'
import HelpSubmissionPopup from '../../Popups/HelpSubmissionPopup'
import PDFPreviewPopup from '../../Popups/PDFPreviewPopup'
import styles from './styles'

const ClientCodesButtons = ({
  classes,
  campaigns,
  isCodesUploading,
  setIsCodesUploading,
  selectedRows,
  onCodesDeleted,
  isActionsDisabled,
  onRefetch,
  mapCodesTable,
  setInternalStatus,
  setShowCodesExplanationPage,
}) => {
  const { campaignId } = useParams()
  const campaign = campaigns[campaignId]

  const [isCodeUploadPopupOpen, setIsCodeUploadPopupOpen] = useState(false)
  const [isConfirmationPopupOpen, setIsConfirmationPopupOpen] = useState(false)
  const [isPDFPreviewPopupOpen, setIsPDFPopupPreviewOpen] = useState(false)
  const [isHelpSubmissionOpen, setIsHelpSubmissionOpen] = useState(false)
  const [isCodesDeleting, setIsCodesDeleting] = useState(false)
  const isAdmin = authorization.getUser().role === 'ADMIN'

  const onDelete = async () => {
    setIsCodesDeleting(true)
    try {
      const response = await deleteClientCodes({
        campaignId: campaignId,
        codeIds: selectedRows,
      })
      const result = await response.json()
      const codes = result.data.deleteClientCodes.clientCodes
      mapCodesTable(codes)
    } catch (e) {
      console.error({ e })
    } finally {
      setIsCodesDeleting(false)
      setIsConfirmationPopupOpen(false)
      onCodesDeleted()
    }
  }

  return (
    <div className={classes.controlsBlock}>
      <ClientCodeUploadPopup
        isOpen={isCodeUploadPopupOpen}
        onClose={() => setIsCodeUploadPopupOpen(false)}
        mapCodesTable={mapCodesTable}
        campaignId={campaignId}
        isCodesUploading={isCodesUploading}
        setIsCodesUploading={setIsCodesUploading}
        onRefetch={onRefetch}
        setShowCodesExplanationPage={setShowCodesExplanationPage}
      />
      <ConfirmationPopup
        onCancel={() => {
          setIsConfirmationPopupOpen(false)
        }}
        isOpen={isConfirmationPopupOpen}
        onConfirm={onDelete}
        isInProgress={isCodesDeleting}
      />
      <PDFPreviewPopup
        campaignId={campaign.id}
        onCancel={() => {
          setIsPDFPopupPreviewOpen(false)
        }}
        isOpen={isPDFPreviewPopupOpen}
      />
      {isHelpSubmissionOpen ? (
        <HelpSubmissionPopup
          onCancel={() => {
            setIsHelpSubmissionOpen(false)
          }}
          isOpen={isHelpSubmissionOpen}
          setInternalStatus={setInternalStatus}
        />
      ) : null}
      <div className={classes.buttons}>
        <Button
          disabled={isActionsDisabled}
          className={classes.button}
          variant="outlined"
          onClick={() => setIsCodeUploadPopupOpen(true)}
        >
          Upload Codes
        </Button>
        <Button
          className={classes.button}
          variant="outlined"
          disabled={!selectedRows.length || isActionsDisabled}
          onClick={() => {
            setIsConfirmationPopupOpen(true)
          }}
        >
          Delete
        </Button>
        <Button
          className={classes.button}
          variant="outlined"
          onClick={() => {
            setIsPDFPopupPreviewOpen(true)
          }}
        >
          View Flyer Design
        </Button>
      </div>
      {!isAdmin && !isActionsDisabled ? (
        <div
          className={classes.tip}
          onClick={() => {
            setIsHelpSubmissionOpen(true)
          }}
        >
          Unable to provide this data? Click here
        </div>
      ) : null}
    </div>
  )
}

const mapStateToProps = (state, props) => ({
  campaigns: state.campaigns.campaigns,
  state: state,
})

export default connect(mapStateToProps)(withStyles(styles)(ClientCodesButtons))
